import { render } from "./UserListTableCellTeacherClasses.vue?vue&type=template&id=37ee7f81&scoped=true&ts=true"
import script from "./UserListTableCellTeacherClasses.vue?vue&type=script&lang=ts"
export * from "./UserListTableCellTeacherClasses.vue?vue&type=script&lang=ts"

import "./UserListTableCellTeacherClasses.vue?vue&type=style&index=0&id=37ee7f81&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ee7f81"]])

export default __exports__